export default{
    cadastra:{
        method:'post',
        url:'boletins/tabela/backup'
    },
}